import { configureStore } from '@reduxjs/toolkit'
import { authSlice } from './auth'
import { loadingSlice } from './loading'
import { globalsSlice } from './globals'
import { companySlice } from './company'
import { departamentSlice } from './departament'
import { municipalySlice } from './municipaly'
import { paymentFrequencySlice } from './payment_frequency'
import { paymentMethodSlice } from './payment_method'
import { associatedBankSlice } from './associated_bank'
import { TypeAccountBankSlice } from './type_account_bank'
import { SgsstSlice } from './sgsst'
import { ArlSlice } from './arl'
import { economicActivitySlice } from './economic_activity'
import { ErrorsSlice } from './errors'
import { permissonsSlice } from './permissions'
import { AreaSlice } from './areas'
import { CargoSlice } from './cargos'
import { LogSlice } from './logs'
import { typeDocumentSlice } from './type_document'
import { EpsSlice } from './eps'
import { FamilyCompensationSlice } from './family_compensation_fund'
import { CesantiasSlice } from './severance'
import { PensionSlice } from './pension'
import { SizeFamilySlice } from './size_family'
import { EmployeeSlice } from './employee'
import { TurnoSlice } from './shifts'
import { Parametroslice } from './parameters'
import { TipoNovedadSlice } from './tipo_novedad'
import { CustomerSlice } from './customer'
import { novedadesTurnoSlice } from './novedadesTurnos'
import { UsersPermissionsSlice } from './users_permissions'
import { countrySlice } from './country'
import { workPlaceSlice } from './work_place'
import { sucursalSlice } from './sucursal'
import { shiftsEmployeesSlice } from './shifts_employees'
import { Terminalslice } from './terminals'

export default configureStore({
  reducer: {
    auth: authSlice.reducer,
    loading: loadingSlice.reducer,
    globals: globalsSlice.reducer,
    company: companySlice.reducer,
    departaments: departamentSlice.reducer,
    municipalies: municipalySlice.reducer,
    paymentfrequency: paymentFrequencySlice.reducer,
    paymentmethod: paymentMethodSlice.reducer,
    associatedbank: associatedBankSlice.reducer,
    typeaccountbank: TypeAccountBankSlice.reducer,
    sgsst: SgsstSlice.reducer,
    arl: ArlSlice.reducer,
    economicactivity: economicActivitySlice.reducer,
    errors: ErrorsSlice.reducer,
    permissions: permissonsSlice.reducer,
    areas: AreaSlice.reducer,
    cargos: CargoSlice.reducer,
    logs: LogSlice.reducer,
    tipodocumento: typeDocumentSlice.reducer,
    eps: EpsSlice.reducer,
    cajaCompensacion: FamilyCompensationSlice.reducer,
    cesantias: CesantiasSlice.reducer,
    pension: PensionSlice.reducer,
    sizefamily: SizeFamilySlice.reducer,
    employee: EmployeeSlice.reducer,
    turnos: TurnoSlice.reducer,
    parametros: Parametroslice.reducer,
    tiponovedades: TipoNovedadSlice.reducer,
    customer: CustomerSlice.reducer,
    novedadesTurno: novedadesTurnoSlice.reducer,
    usersPermissions: UsersPermissionsSlice.reducer,
    country: countrySlice.reducer,
    workplace: workPlaceSlice.reducer,
    sucursales: sucursalSlice.reducer,
    tipoTurnos: shiftsEmployeesSlice.reducer,
    terminals: Terminalslice.reducer
  }
})

